// A new page starts at its top. The app changes pages without loading, so the
// browser kept the old page's scroll: "Build your bot free" from the pricing
// section opened the wizard scrolled to its bottom. Back and forward keep the
// browser's restored position, and an address with a #section is left to the
// page (Home scrolls to it).
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const type = useNavigationType();
  useEffect(() => {
    if (type === "POP" || hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash, type]);
  return null;
}
